import { Checkbox } from '@foam/buoy/src/components/Checkbox/Checkbox';
import { cn } from '@foam/buoy/src/lib/utils';
import { forwardRef, memo, useCallback } from 'react';

interface CheckboxWrapperProps {
  children: React.ReactNode;
  showCheckbox: boolean;
  isChecked: boolean;
  onCheckboxChange?: (checked: boolean) => void;
}

const CheckboxWrapperComponent = forwardRef<
  HTMLDivElement,
  CheckboxWrapperProps
>(({ children, showCheckbox, isChecked, onCheckboxChange }, ref) => {
  const handleCheckboxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onCheckboxChange?.(e.target.checked);
    },
    [onCheckboxChange],
  );

  const handleContainerClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
    },
    [],
  );

  if (!showCheckbox) {
    return <div ref={ref}>{children}</div>;
  }

  return (
    <div ref={ref} className="group/checkbox cursor-pointer">
      <div
        className={cn(
          'absolute right-3 top-3 z-10',
          'transition-[opacity,transform] duration-200 ease-in-out',
          'opacity-0 scale-75 group-hover/checkbox:opacity-100 group-hover/checkbox:scale-100',
          isChecked && 'opacity-100 scale-100',
        )}
        onClick={handleContainerClick}
      >
        <Checkbox
          checked={isChecked}
          onChange={handleCheckboxChange}
          size="large"
          aria-label="Select content"
        />
      </div>
      {children}
    </div>
  );
});

export const CheckboxWrapper = memo(CheckboxWrapperComponent);
